import {
    Component,
    effect,
    EventEmitter,
    inject,
    Input,
    Output,
    signal
} from "@angular/core";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { BottomMenuComponentListType } from "@app/shared/components/dsn/bottom-menu/bottom-menu.component";
import { MenuOption } from "@app/shared/components/dsn/button-menu-bubbles/button-menu-bubbles.component";
import { SelectOption } from "@app/shared/components/dsn/custom-select/custom-select.component";
import { MenuBottomMobileComponent } from "@app/shared/components/menu-bottom-mobile/menu-bottom-mobile.component";
import { NandaSheetComponent } from "@app/shared/components/nanda-sheet/nanda-sheet.component";
import { SharedDsnModule } from "@app/shared/modules/shared-dsn.module";
import { SharedMaterialModule } from "@app/shared/modules/shared-material.module";
import { ChatNandaService } from "@app/shared/services/chat-nanda.service";
import { ContactService } from "@app/shared/services/contact.service";
import { DrawerService } from "@app/shared/services/drawer.service";
import { VisualizationSortService } from "@app/shared/services/visualization-sort.service";
import { PeriodNames } from "@arch/_shared/types/interval-dates";
import { EventsService } from "@arch/domain/application/services/events.service";
import { ReportPreferenceService } from "@arch/domain/application/services/report-preference.service";
import { CompanyEntity } from "@arch/domain/entity/company.entity";
import { ReportEntity } from "@arch/domain/entity/report.entity";
import { ScenarioEntity } from "@arch/domain/entity/scenario.entity";
import {
    NavigationItem,
    ReportAdjustmentsSidenavComponent
} from "../../components/report-adjustments-sidenav/report-adjustments-sidenav.component";
import { ReportBeachmarkingSectionComponent } from "../../components/report-beachmarking-section/report-beachmarking-section.component";
import { ReportFeedbackFormComponent } from "../../components/report-feedback-form/report-feedback-form.component";
import { ReportHeaderComponent } from "../../components/report-header/report-header.component";
import { ReportPerformanceComponent } from "../../components/report-performance/report-performance.component";
import {
    EventChangeComparationParams,
    EventChangePeriodParams,
    ReportToolbarComponent
} from "../../components/report-toolbar/report-toolbar.component";
import { ReportVisualizationComponent } from "../../components/report-visualization/report-visualization.component";
@Component({
    selector: "app-mobile-dashboard",
    imports: [
        SharedDsnModule,
        SharedMaterialModule,
        ReportHeaderComponent,
        SharedMaterialModule,
        ReportHeaderComponent,
        ReportToolbarComponent,
        ReportVisualizationComponent,
        ReportAdjustmentsSidenavComponent,
        ReportFeedbackFormComponent,
        ReportBeachmarkingSectionComponent,
        ReportPerformanceComponent,
        MenuBottomMobileComponent
    ],
    templateUrl: "./mobile.component.html",
    styleUrl: "./mobile.component.scss"
})
export class MobileComponent {
    public readonly preferenceService = inject(ReportPreferenceService);

    @Input({ required: true }) loading: boolean;
    @Input({ required: true }) report: ReportEntity;
    @Input({ required: true }) company: CompanyEntity;
    @Input() previewMode: boolean = false;
    @Input({ required: false }) set accordionState(value: string) {
        this.onListenerAccordion(value);
    }
    @Output() handleResetPeriod: EventEmitter<void> = new EventEmitter();
    @Output() handleChangePeriod: EventEmitter<{
        scenario: ScenarioEntity;
        periodName: PeriodNames;
        startDate: Date;
        endDate: Date;
    }> = new EventEmitter();
    @Output() handleChangeComparation: EventEmitter<{
        scenario: ScenarioEntity;
        periodName: PeriodNames;
        dateBase: Date;
        comparationDate: Date;
        allMonthsCompare?: boolean;
    }> = new EventEmitter();
    @Output() handleChangeAnalysis: EventEmitter<{
        projection: ScenarioEntity;
        budget: ScenarioEntity;
        goals: boolean;
    }> = new EventEmitter();
    @Output() handleResetAnalysis: EventEmitter<void> = new EventEmitter();
    @Input() isPreviewMode?: boolean = false;

    private readonly bottomSheet = inject(MatBottomSheet);
    private readonly nandaChatService = inject(ChatNandaService);
    private readonly eventsService = inject(EventsService);
    private readonly contactService = inject(ContactService);
    private readonly drawerService = inject(DrawerService);

    public contact = this.contactService.get();
    public listMenu: BottomMenuComponentListType[] = [
        {
            label: "Navegar",
            icon: "fa-solid fa-bars"
        },

        {
            label: "Dicas",
            icon: "fa-solid fa-lightbulb"
        },
        {
            label: "Nanda",
            value: "nanda",

            iconCustom: {
                src: "/images/logos/nanda-icon-logo.svg",
                width: "24px",
                height: "24px"
            }
        }
    ];

    public selectedAnalysisType: selectedAnalysisType = {
        projection: null,
        budget: null,
        goals: false
    };
    public drawerOpen: boolean = false;
    public initialPageSidenav: NavigationItem = null;
    public sectionStates: { [key: string]: boolean } = {
        SectionBenchmarking: true,
        SectionPerformance: true,
        SectionNavigationTips: true,
        SectionIndicators: true,
        SectionFeedback: true
    };
    private readonly visualizationSortService = inject(
        VisualizationSortService
    );
    public orderOptions = this.visualizationSortService.sortOptions;
    public selectedOrder: string = "Relevância";
    public hasBenchmarking: boolean = true;

    public bubblesMenuOptions: MenuOption[] = [
        {
            icon: "fas fa-bars",
            label: "Navegar",
            value: "navigation"
        },
        {
            icon: "fas fa-star",
            label: "Avaliar",
            value: "avaliar"
        },
        {
            icon: "fas fa-lightbulb",
            label: "Dicas",
            value: "dicas"
        }
    ];
    private pageInternalNavigation: NavigationItem = {
        label: "Navegação",
        icon: "fa-solid fa-bars",
        description: "Navegue pelas páginas do Dash.",
        page: 4
    };

    private readonly accordionStateSignal = signal<string>(this.accordionState);
    constructor() {
        this.drawerService.drawerState$.subscribe((state) => {
            this.drawerOpen = state;
            if (!state) {
                this.initialPageSidenav = null;
            }
        });

        effect(() => {
            const accordionState = this.accordionStateSignal();
            this.onListenerAccordion(accordionState);

            if (!this.loading) {
                this.listMenu[2].disabled =
                    this.previewMode &&
                    this.contactService.get()?.props?._id !== "convidadoId";
            }
        });
    }

    public handleMenu(option: BottomMenuComponentListType): void {
        switch (option.value) {
            case "nanda":
                this.nandaChatService.open();
                this.onOpenSheetNandaChat();
                break;
        }
    }

    public onOpenSheetNandaChat(): void {
        const bottomSheetRef = this.bottomSheet.open(NandaSheetComponent, {
            data: {
                report: this.report,
                company: this.company,
                contact: this.contactService.get()
            }
        });

        bottomSheetRef.afterDismissed().subscribe(() => {
            this.nandaChatService.close();
        });
    }

    public onDrawerClosed(): void {
        this.drawerService.closeDrawer();
    }

    public onOptionSelected(event: {
        id: string;
        sectionId?: string;
        visualizationId?: string;
    }): void {
        Object.keys(this.sectionStates).forEach((key) => {
            this.sectionStates[key] = false;
        });
        this.sectionStates[event.id] = true;

        if (event.visualizationId) {
            setTimeout(() => {
                const element = document.getElementById(event.visualizationId);

                if (element) {
                    setTimeout(() => {
                        element.scrollIntoView({
                            behavior: "smooth",
                            block: "start"
                        });
                    }, 545);
                }
            }, 100);
        }
        if (event.sectionId == "nanda") {
            this.eventsService.send(
                `Dash.${this.report.type}.${this.report.humanSourceName}.abrir-nanda`
            );
        }
    }

    public toggleSection(
        event: boolean,
        index?: number,
        sectionId?: string
    ): void {
        if (index !== undefined) {
            if (event) {
                if (this.sectionStates[sectionId]) {
                    delete this.sectionStates[sectionId];
                } else {
                    this.sectionStates[sectionId] = true;
                }
            }
        }
    }

    public onOrderChange(option: SelectOption): void {
        this.selectedOrder = option.label;
    }

    public get sortedVisualizations() {
        const visualizationsVisible = this.report.getVisualizationsVisible();
        if (!visualizationsVisible?.length) {
            return [];
        }
        return this.visualizationSortService.sortVisualizations(
            visualizationsVisible,
            this.selectedOrder
        );
    }

    public onSelectOptionBubbles(option: MenuOption): void {
        switch (option.value) {
            case "navigation":
                this.initialPageSidenav = this.pageInternalNavigation;

                this.drawerService.toggleDrawer();
                break;
            case "dicas":
                Object.keys(this.sectionStates).forEach((key) => {
                    this.sectionStates[key] = false;
                });
                this.sectionStates["SectionNavigationTips"] = true;
                setTimeout(() => {
                    const element = document.getElementById(
                        "SectionNavigationTips"
                    );
                    if (element) {
                        element.scrollIntoView({
                            behavior: "smooth",
                            block: "start"
                        });
                    }
                }, 100);
                break;
            case "avaliar":
                Object.keys(this.sectionStates).forEach((key) => {
                    this.sectionStates[key] = false;
                });
                this.sectionStates["SectionFeedback"] = true;
                setTimeout(() => {
                    const element = document.getElementById("SectionFeedback");
                    if (element) {
                        element.scrollIntoView({
                            behavior: "smooth",
                            block: "start"
                        });
                    }
                }, 100);
                break;
        }
    }

    private onListenerAccordion(accodionId: any): void {
        if (!accodionId) return;
        Object.keys(this.sectionStates).forEach((key) => {
            this.sectionStates[key] = false;
        });
        this.sectionStates[accodionId] = true;
    }

    public onChangePeriod(event: EventChangePeriodParams): void {
        this.drawerService.closeDrawer();
        this.handleChangePeriod.emit(event);
    }

    public onChangeComparation(event: EventChangeComparationParams): void {
        if (this.drawerService) {
            this.drawerService.closeDrawer();
        }
        this.handleChangeComparation.emit(event);
    }

    public onResetPeriod(): void {
        if (this.drawerService) {
            this.drawerService.closeDrawer();
        }
        this.handleResetPeriod.emit();
    }

    public onChangeAnalysis(analysis: selectedAnalysisType): void {
        this.drawerService.closeDrawer();
        this.selectedAnalysisType = analysis;
        this.handleChangeAnalysis.emit(analysis);
    }

    public onSelectProjection(event: ScenarioEntity): void {
        this.selectedAnalysisType.projection = event;
    }

    public onClearAnalysis(type: string): void {
        const selectedAnalysis = (this.selectedAnalysisType as any)[type];
        if (selectedAnalysis) {
            switch (type) {
                case "projection":
                    this.selectedAnalysisType.projection = null;
                    break;
                case "budget":
                    this.selectedAnalysisType.budget = null;
                    break;

                case "goals":
                    this.selectedAnalysisType.goals = false;
                    break;
            }
        }

        this.handleChangeAnalysis.emit(this.selectedAnalysisType);
    }
    public onResetAnalysis(): void {
        this.drawerService.closeDrawer();
        this.selectedAnalysisType = {
            projection: null,
            budget: null,
            goals: false
        };
        this.handleResetAnalysis.emit();
    }

    public onBenchmarkingDataLoaded(hasBenchmarkingData: boolean): void {
        this.hasBenchmarking = hasBenchmarkingData;
    }
}

type selectedAnalysisType = {
    projection: ScenarioEntity;
    budget: ScenarioEntity;
    goals: boolean;
};
